// extracted by mini-css-extract-plugin
export default {"ReactionsMenuOption":"ReactionsMenuItem-module__ReactionsMenuOption--uvJoP"};